"use strict";

function Theme(application) {
  this.application = application || "Cameramanager";
  this.mapping = {
    Cameramanager: "een",
    Civitas: "civitas",
    "Pronet Kameram": "pronet",
    "Live TIM": "livetim",
    "Zain Camera": "zaincamera",
    KC: "kc",
    "Wilhelmina BabyLive!": "wilhelminababylive",
    "Deventer Ziekenhuis": "deventerziekenhuis",
    Visiocam: "visiocam",
    "Een Veilig Gevoel": "eenveiliggevoel",
    IntelliSurveillance: "intellisurveillance",
    "Prosegur Cloud Video": "prosegur",
    Yourstore: "yourstore",
    Easy2Begin: "easy2begin",
    "Hogeschool Utrecht": "hogeschoolutrecht",
    "Amphia Babycam": "amphiababycam",
    "Babycam Diakonessenhuis": "babycamdiakonnessenhuis",
    "Erasmus MC Sophia Babywatch": "erasmusmcsophiababywatch",
    "GizmoSmart Cam": "gizmosmartcam",
    igoview: "igoview",
    Telepet: "telepet",
    "Alibi Cloud VS": "alibi",
    "Twelve Camera": "twelve",
    NuboCam: "nubocam",
    Brivo: "brivo",
    hanwha: "hanwha",
    ionodes: "ionodes",
    capture: "capture",
  };
  this.themes = {
    een: {
      colors: {
        primary: "#207CAD",
        secondary: "#CCCCCC",
        accent: "#207CAD",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#F6F6F6",
        shadow: "#EEEEEE",
      },
      logo: "een-logo-white.png",
      logoNavigation: "een-logo-navigation.png",
      logoLogin: "een-logo-large.png",
      companyName: "Eagle Eye Networks",
      vmsLink: "https://login.eagleeyenetworks.com/",
      favicon: "favicon.ico",
      links: {
        support: "",
        showdealerdashboard: true,
        showDownloadPortal: true,
        privacyPolicy: true,
        cookies: true,
        terms: true,
      },
    },
    pronet: {
      colors: {
        primary: "#EE7413",
        secondary: "#CCCCCC",
        accent: "#EE7413",
        info: "#0B77B4",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#333",
        title: "#EE7413",
        shadow: "#EEEEEE",
      },
      logo: "pronet-logo.svg",
      logoNavigation: "pronet-logo.svg",
      companyName: "Eagle Eye Networks",
      favicon: "favicon-pronet.ico",
      links: {
        support: "",
        webapp: "https://pronet.webapp.cameramanager.com",
        downloadportal: "https://pronet.downloadportal.cameramanager.com",
        myaccount: "https://pronet.myaccount.cameramanager.com",
        dealerdashboard: "https://pronet.dashboard.cameramanager.com",
        showdealerdashboard: false,
        showDownloadPortal: true,
        privacyPolicy: true,
        cookies: true,
        terms: true,
      },
    },
    prosegur: {
      colors: {
        primary: "#EDC201",
        secondary: "#CCCCCC",
        accent: "#EDC201",
        info: "#0B77B4",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#333",
        title: "#EDC201",
        shadow: "#EEEEEE",
      },
      logo: "Prosegur.svg",
      logoNavigation: "Prosegur.svg",
      companyName: "Eagle Eye Networks",
      favicon: "favicon-prosegur.ico",
      links: {
        support: "",
        webapp: "https://prosegur.webapp.cameramanager.com",
        downloadportal: "https://prosegur.downloadportal.cameramanager.com",
        myaccount: "https://prosegur.myaccount.cameramanager.com",
        dealerdashboard: "https://prosegur.dashboard.cameramanager.com",
        showdealerdashboard: false,
        showDownloadPortal: true,
        privacyPolicy: true,
        cookies: true,
        terms: true,
      },
    },
    nubocam: {
      colors: {
        primary: "#3a3d51",
        secondary: "#CCCCCC",
        accent: "#3a3d51",
        info: "#0B77B4",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#333",
        title: "#3a3d51",
        shadow: "#EEEEEE",
      },
      logo: "nubo-logo-white.svg",
      logoNavigation: "nubo-logo-purple.svg",
      companyName: "Eagle Eye Networks",
      favicon: "favicon-nubocam.ico",
      links: {
        support: "",
        webapp: "https://webapp.nubocam.com",
        downloadportal: "https://downloadportal.nubocam.com",
        myaccount: "https://myaccount.nubocam.com",
        showdealerdashboard: false,
        showDownloadPortal: true,
        privacyPolicy: true,
        cookies: true,
        terms: true,
      },
    },
    ionodes: {
      colors: {
        primary: "#0a7890",
        secondary: "#CCCCCC",
        accent: "#0a7890",
        info: "#0B77B4",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#333",
        title: "#0a7890",
        shadow: "#EEEEEE",
      },
      logo: "ionodes-main.png",
      logoNavigation: "ionodes-main.png",
      favicon: "ionodes-favicon.png",
      links: {
        support: "",
        webapp: "https://webapp.perceptcloud.io/",
        myaccount: "https://myaccount.perceptcloud.io/",
        downloadportal: "",
        showdealerdashboard: false,
        showDownloadPortal: false,
      },
    },
    kochar: {
      colors: {
        primary: "#109CCE",
        secondary: "#CCCCCC",
        accent: "#109CCE",
        info: "#0B77B4",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#333",
        title: "#109CCE",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    civitas: {
      colors: {
        primary: "#093371",
        secondary: "#CCCCCC",
        accent: "#093371",
        info: "#093371",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#093371",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    livetim: {
      colors: {
        primary: "#477AAD",
        secondary: "#CCCCCC",
        accent: "#477AAD",
        info: "#477AAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#477AAD",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    zaincamera: {
      colors: {
        primary: "#8FD2C5",
        secondary: "#CCCCCC",
        accent: "#8FD2C5",
        info: "#8FD2C5",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#8FD2C5",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    kc: {
      colors: {
        primary: "#C1022C",
        secondary: "#CCCCCC",
        accent: "#C1022C",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#C1022C",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    wilhelminababylive: {
      colors: {
        primary: "#00539F",
        secondary: "#CCCCCC",
        accent: "#00539F",
        info: "#00539F",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#00539F",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    deventerziekenhuis: {
      colors: {
        primary: "#CC2773",
        secondary: "#CCCCCC",
        accent: "#CC2773",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#CC2773",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    visiocam: {
      colors: {
        primary: "#9D0313",
        secondary: "#CCCCCC",
        accent: "#9D0313",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#9D0313",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    eenveiliggevoel: {
      colors: {
        primary: "#65B417",
        secondary: "#CCCCCC",
        accent: "#65B417",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#65B417",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    intellisurveillance: {
      colors: {
        primary: "#3BB8FF",
        secondary: "#CCCCCC",
        accent: "#3BB8FF",
        info: "#3BB8FF",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#3BB8FF",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    yourstore: {
      colors: {
        primary: "#9DD4E9",
        secondary: "#CCCCCC",
        accent: "#9DD4E9",
        info: "#9DD4E9",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#9DD4E9",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    easy2begin: {
      colors: {
        primary: "#AFD253",
        secondary: "#CCCCCC",
        accent: "#AFD253",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#AFD253",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    hogeschoolutrecht: {
      colors: {
        primary: "#ED0010",
        secondary: "#CCCCCC",
        accent: "#ED0010",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#ED0010",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    amphiababycam: {
      colors: {
        primary: "#225D8A",
        secondary: "#CCCCCC",
        accent: "#225D8A",
        info: "#225D8A",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#225D8A",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    babycamdiakonnesenhuis: {
      colors: {
        primary: "#083773",
        secondary: "#CCCCCC",
        accent: "#083773",
        info: "#083773",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#083773",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    erasmusmcsophiababywatch: {
      colors: {
        primary: "#0C2074",
        secondary: "#CCCCCC",
        accent: "#0C2074",
        info: "#0C2074",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#0C2074",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    gizmosmartcam: {
      colors: {
        primary: "#109CCE",
        secondary: "#CCCCCC",
        accent: "#109CCE",
        info: "#109CCE",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#109CCE",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },
    igoview: {
      colors: {
        primary: "#207CAD",
        secondary: "#CCCCCC",
        accent: "#207CAD",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#A1C84F",
        shadow: "#EEEEEE",
      },
      links: {
        support: "",
      },
    },

    brivo: {
      colors: {
        primary: "#739cd2",
        secondary: "#CCCCCC",
        accent: "#739cd2",
        info: "#0B77B4",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#333",
        title: "#739cd2",
        shadow: "#EEEEEE",
      },
      logo: "Brivo-Web-Logo.png",
      logoNavigation: "Brivo-Web-Logo.png",
      favicon: "favicon-brivo.png",
      links: {
        support: "",
        webapp: "https://brivo.webapp.cameramanager.com/",
        myaccount: "https://brivo.myaccount.cameramanager.com/",
        downloadportal: "https://brivo.downloadportal.cameramanager.com",
        showdealerdashboard: false,
        showDownloadPortal: true,
      },
    },
    telepet: {
      colors: {
        primary: "#000",
        secondary: "#CCCCCC",
        accent: "#000",
        info: "#000",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#000",
        shadow: "#EEEEEE",
      },
      logo: "UU_logo.png",
      logoNavigation: "UU_logo.png",
      companyName: "Eagle Eye Networks",
      favicon: "UU-favicon.ico",
      logoWidth: "400px",
      logoHeight: "72px",
      links: {
        webapp: "https://telepet.webapp.cameramanager.com/",
        downloadportal: "https://telepet.downloadportal.cameramanager.com/",
        myaccount: "https://telepet.myaccount.cameramanager.com/",
        showdealerdashboard: false,
        showDownloadPortal: false,
        privacyPolicy: true,
        cookies: true,
        terms: true,
      },
    },
    alibi: {
      colors: {
        primary: "#00A7CF",
        secondary: "#CCCCCC",
        accent: "#00A7CF",
        info: "#00A7CF",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#00A7CF",
        shadow: "#EEEEEE",
      },
      logo: "alibi-logo-white.png",
      logoNavigation: "alibi-logo-white.png",
      companyName: "",
      favicon: "favicon-alibi.ico",
      links: {
        support: "",
        webapp: "https://cloudvslogin.alibisecurity.com/",
        downloadportal: "https://alibi.downloadportal.cameramanager.com",
        myaccount: "https://cloudvsaccount.alibisecurity.com",
        dealerdashboard: "http://cloudvsdashboard.alibisecurity.com/",
        showdealerdashboard: false,
        showDownloadPortal: false,
        privacyPolicy: false,
        cookies: false,
        terms: false,
      },
    },
    hanwha: {
      colors: {
        primary: "#222222",
        secondary: "#CCCCCC",
        accent: "#222222",
        info: "#222222",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#222222",
        shadow: "#EEEEEE",
      },
      logo: "hanwha.png",
      logoNavigation: "hanwha.png",
      logoLogin: "wisenet_logo_large.png",
      companyName: "Wisenetsky",
      vmsLink: "https://wisenetsky.com/",
      vmsApplicationName: "Wisenetsky Cloud VMS",
      favicon: "hanwha.ico",
      links: {
        support: "",
        webapp: "https://cloudvslogin.alibisecurity.com/",
        downloadportal: "https://alibi.downloadportal.cameramanager.com",
        myaccount: "https://cloudvsaccount.alibisecurity.com",
        dealerdashboard: "http://cloudvsdashboard.alibisecurity.com/",
        showdealerdashboard: false,
        showDownloadPortal: false,
        privacyPolicy: false,
        cookies: false,
        terms: false,
      },
    },
    capture: {
      colors: {
        primary: "#207CAD",
        secondary: "#CCCCCC",
        accent: "#207CAD",
        info: "#207CAD",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#F6F6F6",
        shadow: "#EEEEEE",
      },
      logo: "capture.png",
      logoNavigation: "capture.png",
      logoLogin: "capture_blue.png",
      companyName: "Capture Cloud CameraManager",
      vmsLink: "https://http://capturecloudvms.com/",
      vmsApplicationName: "Capture Cloud VMS",
      favicon: "capture.ico",
      links: {
        support: "https://capturecloudcm/support",
        webapp: "https://webapp.capturecloudcm.com/",
        downloadportal: "",
        myaccount: "https://myaccount.capturecloudcm.com/",
        dealerdashboard: "https://dealer.capturecloudcm.com/",
        showdealerdashboard: true,
        showDownloadPortal: false,
        privacyPolicy: false,
        cookies: false,
        terms: false,
      },
    },
    twelve: {
      colors: {
        primary: "#190078",
        secondary: "#CCCCCC",
        accent: "#190078",
        info: "#190078",
        success: "#4CAF50",
        warning: "#D43536",
        error: "#D43536",
        text: "#555",
        title: "#190078",
        shadow: "#EEEEEE",
      },
      logo: "twelve-logo-white.svg",
      logoNavigation: "twelve-logo.svg",
      companyName: "Eagle Eye Networks",
      favicon: "favicon-twelve.ico",
      links: {
        support: "",
        webapp: "https://twelve.webapp.cameramanager.com",
        downloadportal: "https://twelve.downloadportal.cameramanager.com",
        myaccount: "https://twelve.myaccount.cameramanager.com",
        dealerdashboard: "https://twelve.dashboard.cameramanager.com",
        showdealerdashboard: false,
        showDownloadPortal: true,
        privacyPolicy: true,
        cookies: true,
        terms: true,
      },
    },
  };
}

Theme.prototype.shadeColor = function (color, percent) {
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  var RR = R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
  var GG = G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
  var BB = B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
};

Theme.prototype.colors = function () {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  const colors = this.themes.hasOwnProperty(mapping) ? this.themes[mapping].colors : this.themes.een.colors;
  colors.lightprimary = this.shadeColor(colors.primary, 21);
  return { themes: { light: colors }, options: { customProperties: true } };
};

Theme.prototype.logo = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`logo${type}`)
      ? this.themes[mapping][`logo${type}`]
      : null
    : null;
};

Theme.prototype.favicon = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`favicon${type}`)
      ? this.themes[mapping][`favicon${type}`]
      : null
    : null;
};

Theme.prototype.vmsLink = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`vmsLink${type}`)
      ? this.themes[mapping][`vmsLink${type}`]
      : null
    : null;
};

Theme.prototype.vmsApplicationName = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`vmsApplicationName${type}`)
      ? this.themes[mapping][`vmsApplicationName${type}`]
      : null
    : null;
};

Theme.prototype.logoHeight = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`logoHeight${type}`)
      ? this.themes[mapping][`logoHeight${type}`]
      : null
    : null;
};

Theme.prototype.logoWidth = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`logoWidth${type}`)
      ? this.themes[mapping][`logoWidth${type}`]
      : null
    : null;
};

Theme.prototype.logoLogin = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`logoLogin${type}`)
      ? this.themes[mapping][`logoLogin${type}`]
      : null
    : null;
};

Theme.prototype.companyName = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`companyName${type}`)
      ? this.themes[mapping][`companyName${type}`]
      : null
    : null;
};
Theme.prototype.links = function (type = "") {
  const mapping = this.mapping.hasOwnProperty(this.application) ? this.mapping[this.application] : "een";
  return this.themes.hasOwnProperty(mapping)
    ? this.themes[mapping].hasOwnProperty(`links${type}`)
      ? this.themes[mapping][`links${type}`]
      : null
    : null;
};

export default Theme;
